import { render, staticRenderFns } from "./GeralRemuneracaoProfessorComponent.vue?vue&type=template&id=f8618eae&scoped=true&"
import script from "./GeralRemuneracaoProfessorComponent.vue?vue&type=script&lang=js&"
export * from "./GeralRemuneracaoProfessorComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8618eae",
  null
  
)

export default component.exports